import apiUrl from '../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import PageTracker from '../../../../common/PageTrackerHelper'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';;


export default {
  name: 'StoreApproval',
  components: {
      Multiselect,
      VueElementLoading,
      Paginate
  },
  mixins:[PageTracker],
  data: function() {
      return {
        fromDate : '',
        toDate:'',
        searchflag:false,
        localuserid:'',
        localusermailid:'',
        pageno: 1,
        pagecount: 0,
        hubname:'',
        debitFrom:'',
        ShippingId:'',
        ShipmentData:'',
        getShipmentsflag:false,
        selectedItems: [],
        shipmentDetails:[],
        selectAllItems: false,
        DebitShareinRs:'',
        Percentage:'',
        hubID:[],
        hubzoneid:'',
        hubList:[],
        hubZoneList:[],
        amount:0,
        RMApproveAllRecord:'',
        selectEditItemsList : [],
        isAPICallFlag : true,
        adjustDebitAmount : 0,
        isDebitPersonSelected : "",
        debitPersonAmount :[],
        debitPersonPercent :[],
        getShipmentLostMasterID : '',
        getShipmentLostDetailsID : [],
        ShipmentLostMasterID : '',
        Loading: false,
        detailsLoading:false,
        LoaderForPopup:false,
        localhubdetails: '',
        hubinfo: '',
        getAttachmentListData: [],
        getAttachmentFlag: false,
        attachmentLoader: false,
        RmApproveLoaderBtn: false,
        totalRecords:0,
        totalSelectedRecords:0,
        ExportRmApproveLoaderBtn: false,
        approvalDebitResultStatus: [],
        isPendingGroupIdLoader: false,
        modelValue: false,
        styleObjectFailure : {
          'background-color' : 'red'
        },
        styleObjectSuccess: {
          'background-color' : 'green'
        },
        selectAllItems: false,
        newid : [],
        awbnumbers: '',
        ShipmentType: '',
        CenterTypeList: [],
        CenterType : '',
        hubStateList : [],
        hubCitybyStateList : [],
        hubNameList : [],
        hubStateId : '',
        hubCityId : '',
        AORList : [],
        AOR : '',
        selectedHubZoneId : '',
        selectedStateId : '',
        selectedCityId : '',
        selectedAOR : '',
        selectedCenterType : '',
        filteredHubList : [],
        reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
        debitFromModal : false,
        debitPersonDetails : null,
        userDataKey : '',
        heading: '',
        hubAccessList : [],
        selectAll: false,
        allhubList:[],
        totalDebitAmount:0,
        addDebitAmt:0,
        isScroll:false,
        isLoading: false,
        debitAgencyModal : false,
        debitAgencyDetails : null,
      }
  },
  created: function() {
  },
async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];
    this.hubinfo  = await this.getHubDetailsbyID(this.localuserid, this.localhubdetails);
    // console.log('Mixin is working for :',userdetail);
    let getHubList = localStorage.getItem('allhubaccesslist');
    var byteHub = CryptoJS.AES.decrypt(getHubList.toString(), this.userDataKey);
    var hubList = byteHub.toString(CryptoJS.enc.Utf8);
    this.hubAccessList = JSON.parse(hubList);
    this.getHubZoneList();
    this.getCenterTypeList();
    this.getServiceCentreList("");
    this.getHubStateList();
    this.getAORList();
    // this.filterHubList()
    console.log('this.hubAccessList ----------->>', this.hubAccessList);

  },
  methods : {
    calculateselectedcount(event,shipmentDetail){
      this.totalSelectedRecords = this.selectedItems.length
      const checkbox = event.target;
    const checkboxValue = parseInt(shipmentDetail.DebitAmount);

    if (checkbox.checked) {
        // Add value to total
        this.addDebitAmt += parseFloat(checkboxValue);
          this.totalDebitAmount=this.addDebitAmt.toFixed(2)
        // Add the selected item to the selectedItems array
        const selectedItem = objectArray.find(item => item.value === checkboxValue);
        selectedItems.push(selectedItem);
    } else {
        // Subtract value from total
        this.addDebitAmt-= parseFloat(checkboxValue);
        this.totalDebitAmount=this.addDebitAmt.toFixed(2)
        // Remove the deselected item from the selectedItems array
        selectedItems = selectedItems.filter(item => item.value !== checkboxValue);
    }
    this.totalDebitAmount=parseFloat(this.totalDebitAmount)
    console.log( this.totalDebitAmount,"//////////////////////////////")
      
      
     },
    searchData() {
      // if (this.usernames && !this.reg.test(this.usernames)) {
      //   this.$alertify.error('Please enter a valid email address');
      //   return false
      // }
      this.RMApproveAllRecord = false
      this.searchflag = true
      this.pageno = 1
      this.selectedItems = []
      this.shipmentDetails=[]
      this.totalSelectedRecords = 0
      this.totalDebitAmount=0;
      this.addDebitAmt=0;
      this.selectAllItems = false
      this.$refs.paginate.selected= 0;
      this.SearchShipmets()
    },
    SearchShipmets(){
      if(this.toDate >= this.fromDate ){
        this.Loading = true;
        this.searchflag = true;

        let hubIDarray = []
        if(this.hubID.length > 0 ){
          this.hubID.map(hub=>{
            hubIDarray.push(hub.HubID)
          })
        }else{
          if(this.filteredHubList.length > 0){
            this.filteredHubList.map(hub=>{
              hubIDarray.push(hub.HubID)
            })
          }else{
            this.Loading = false;
            this.ShipmentData=[];
            this.totalRecords=0;
            this.pagecount = 0;
            this.$alertify.error("No SVC found for selected filter's..!")
            return false;
          }
        }
        if (this.ShipmentType =="All"){
          this.ShipmentType = ""
        }
        let data={
            fromDate:this.fromDate ,
            toDate: this.toDate,
            HubZoneID: this.hubzoneid.toString(),
            HubId: hubIDarray,
            CenterType: this.CenterType,
            offset : this.pageno - 1,
            limit : 100,
            ShippingID:this.awbnumbers,
            isCsvDownload: false,
            ShipmentType : this.ShipmentType,
            AOR : this.AOR,
        };
        if (this.awbnumbers.length>0) {
         let shippingId=this.awbnumbers.split(/[\s,]+/);
         let shipmentReqArray = [];
         $.each(shippingId, (key,shipmentId)=>{
           if(shipmentId != ''){
             shipmentReqArray.push(shipmentId.trim())
           }
           if(shipmentReqArray.length > 100){
             this.$alertify.error("Maximum 100 shippingID you can enter.")
           }else{
             data.ShippingID = shipmentReqArray;
           }
         })
       }
        // if (this.usernames){
        //   let userNameArr = []
        //   userNameArr.push(this.usernames)
        //   data.username = userNameArr
        // }
        axios.post(apiUrl.api_url + 'shipmentLost/StoreApproval/getShipmentList',data)
          .then((response) => {
            if(response.data.code == 200){
              this.searchflag=true;
              this.ShipmentData = response.data.data;
              this.ShipmentData.map(data => {
                data.DebitPersonalDetails.map(data2 => {
                  data.DebitDate = data2.CreatedDate//!= undefined ? data.DebitPersonalDetails[0].CreatedDate : ""
                })
              })
              this.Loading = false;
               let totalRows = response.data.totalCount;
               this.totalRecords = totalRows
               if (totalRows < 100) {
                   this.pagecount = 1;
               } else {
                   this.pagecount = Math.ceil(totalRows / 100)
               }
            }else if(response.data.code == 204) {
              this.searchflag= false;
              this.Loading = false;
              this.ShipmentData = [];
              this.$alertify.error("No Pending Approval");
            }else if(response.data.code == 202) {
              this.Loading = false;
              this.ShipmentData = [];
              this.$alertify.error(response.data.message);
            }else{
              this.Loading = false;
              this.ShipmentData = [];
              this.$alertify.error(response.data.message);
            }
          })
        .catch((httpException) => {
            console.error('exception is:::::::::',httpException)
        });
      }
      else {
        this.$alertify.error("To Date is greter than from Date");
      }
  },

     getHubList(hubZoneID){
       let url = 'UpdateShipment/gethublist';
       if(hubZoneID != 'hubList') url = `external/getzonewisehublist?zoneid=${hubZoneID}`;

       axios.get(apiUrl.api_url + url)
         .then((response) => {
             if(response.data.code ==200){
                 this.hubList=response.data.data;
                 this.hubList.sort(function(a, b){
                  var nameA=a.HubName.toLowerCase(), nameB=b.HubName.toLowerCase()
                  if (nameA < nameB) //sort string ascending
                   return -1
                  if (nameA > nameB)
                   return 1
                  return 0 //default return value (no sorting)
                 });
                 console.log(this.hubList,">>>>>>>>>>>>>>>");  
             }
             else {
                 this.hubList=[];
             }
         })
         .catch((httpException) => {
               this.$alertify.error("Hub List not found");
               console.error('exception is:::::::::', httpException)
         })
     },
     getHubZoneList(){
        var hubZone=[]
        this.hubAccessList.filter(element=>{
          const existingIndex = hubZone.findIndex(item => item.HubZoneId === element.HubZoneId);
              if (existingIndex != -1) {
              hubZone[existingIndex] = element;
            } else {
              hubZone.push(element);
            }
        });
        this.hubZoneList=hubZone;
        console.log(this.hubZoneList);
        
     },
     
  getCenterTypeList() {
    axios.post(apiUrl.api_url + 'external/getCentreTypeList')
      .then((response) => {
        if (response.data.code == 200) {
          this.CenterTypeList = response.data.data;
        }
        else {
          this.CenterTypeList = [];
          this.$alertify.error(response.data.message);

        }
      })
      .catch((httpException) => {
        console.error('exception is:::::::::', httpException)
      })
  },
  
  approveAllRecolrd(){
       if(this.selectedItems.length == 0){
         this.$alertify.error("please select atleast one Record");
       }else {
         let endResult=[];
         this.RmApproveLoaderBtn = true
         for (let i = 0; i < this.selectedItems.length; i++) {
           let result = this.ShipmentData.find( shipmentData => shipmentData.ShipmentLostMasterID == this.selectedItems[i] );
           endResult.push(result)
         }
         let payload=[];
         for (let j = 0; j < endResult.length; j++) {
           let debitPersonDetailsArray=[];
          for (let p = 0; p < endResult[j].DebitPersonalDetails.length; p++) {
            console.log(endResult[j].DebitPersonalDetails[p],"oooool");
            let debitPersonDetailsobj={
              ShipmentLostDetailsID:endResult[j].DebitPersonalDetails[p].ShipmentLostDetailsID?endResult[j].DebitPersonalDetails[p].ShipmentLostDetailsID:'0',
              DebitAmount:endResult[j].DebitPersonalDetails[p].DebitAmount?endResult[j].DebitPersonalDetails[p].DebitAmount:0.00,
              // DebitPercentage:endResult[j].DebitPersonalDetails[p].DebitPercentage
            }
            debitPersonDetailsArray.push(debitPersonDetailsobj);
          }
          console.log(debitPersonDetailsArray, ">>>>>>>>>>>>>>")
          this.newid.push(endResult[j].ShipmentLostMasterID)
            let data=  {
                        "ShipmentLostMasterID": endResult[j].ShipmentLostMasterID,
                        "DebitPersonDetails":debitPersonDetailsArray,
                        "Comments": "Success",
                        "LastModifiedBy":this.localusermailid
                    }
            payload.push(data);
         }
         axios.post(apiUrl.api_url + 'shipmentLost/StoreApproval/approveDebit',payload)
         .then((response) => {
           let masterID = String(this.newid)
           let TrackerInfo = {
            projectname:"Last Mile",
            type:"Web",
            userid:this.localuserid,
            username:this.localusermailid,
            meta :
            {
              "event":"RMApproval",
              "ShipmentLostMasterID" : masterID
            }
          }
          this.PageTracker(TrackerInfo);
           this.modelValue = true
           this.approvalDebitResultStatus = response.data.data;
           console.log(this.approvalDebitResultStatus)
           const uniqueData = this.approvalDebitResultStatus.filter((item, index, self) => 
            index === self.findIndex((t) => t.ShipmentLostMasterID === item.ShipmentLostMasterID)
          );
          this.approvalDebitResultStatus=uniqueData
           this.approvalDebitResultStatus.forEach((obj) => {
             this.ShipmentData.find(shipmentData => {
               if( shipmentData.ShipmentLostMasterID == obj.ShipmentLostMasterID) {
                 obj.shippingIDs = shipmentData.ShippingID
               }
             })
           })
           let vm = this
           setTimeout(function(){
             vm.modelValue = false
             vm.searchData();
           }, 20000);
           if(response.data.code=200){
              // this.$alertify.success(response.data.message);
              this.selectedItems = [];
              this.shipmentDetails=[];
           } else if(response.data.code=202) {
             // this.$alertify.error(response.data.message);
           }else {
             // this.$alertify.error("Internal server Error");
           }
           this.RmApproveLoaderBtn = false
          //  this.totalSelectedRecords = 0
         })
       .catch((httpException) => {
         this.RmApproveLoaderBtn = false
         this.totalSelectedRecords = 0
         this.totalDebitAmount=0;
        this.addDebitAmt=0;
           console.error('exception is:::::::::',httpException)
       });
       }
     },
   
     getShipmentAttachmentPopup(shippingID){
       this.attachmentLoader = true
       this.getAttachmentFlag= true
       let data={
         ShippingID: shippingID
       }
       axios.post(apiUrl.api_url + 'Lost/ShippindID/AttachmentDownload',data)
         .then((response) => {
             if(response.data.code == 200){
                this.getAttachmentListData = response.data.data;
             } else {
               this.getAttachmentListData = [];
             }
             this.attachmentLoader = false;
           })
         .catch((httpException) => {
              this.attachmentLoader = false;
             console.error('exception is:::::::::',httpException)
         });
     },
     closeAttachmentPopup(){
      this.getAttachmentFlag = false
     },
   
     getPaginationData(pageNum) {
       this.pageno = pageNum;
       this.selectedItems = []
       this.shipmentDetails=[]
       this.totalSelectedRecords = 0
       this.selectAllItems = false
       this.SearchShipmets();
     },
     
///THIS CSV DOWNLOAD START
downloadCsv() {
  if(this.toDate >= this.fromDate ){

    this.ExportRmApproveLoaderBtn = true;
    let hubIDarray = []
        if(this.hubID.length > 0 ){
          this.hubID.map(hub=>{
            hubIDarray.push(hub.HubID)
          })
        }else{
          if(this.filteredHubList.length > 0){
            this.filteredHubList.map(hub=>{
              hubIDarray.push(hub.HubID)
            })
          }else{
            this.Loading = false;
            this.ExportRmApproveLoaderBtn = false;
            this.ShipmentData=[];
            this.totalRecords=0;
            this.pagecount = 0;
            this.$alertify.error("No SVC found for selected filter's..!")
            return false;
          }
        }
    if (this.ShipmentType =="All"){
      this.ShipmentType = ""
    }
    let data={
        fromDate:this.fromDate ,
        toDate: this.toDate,
        HubZoneID: this.hubzoneid.toString(),
        // DebitFromType: this.debitFrom,
        HubId: hubIDarray,
        CenterType: this.CenterType,
        offset : this.pageno - 1,
        limit : 100,
        ShippingID:this.awbnumbers,
        isCsvDownload: false,
        ShipmentType : this.ShipmentType
    };
    if (this.awbnumbers.length>0) {
      let shippingId=this.awbnumbers.split(/[\s,]+/);
      let shipmentReqArray = [];
      $.each(shippingId, (key,shipmentId)=>{
        if(shipmentId != ''){
          shipmentReqArray.push(shipmentId.trim())
        }
        if(shipmentReqArray.length > 100){
          this.$alertify.error("Maximum 100 shippingID you can enter.")
        }else{
          data.ShippingID = shipmentReqArray;
        }
      })
    }
    axios.post(apiUrl.api_url + 'shipmentLost/StoreApproval/getShipmentList',data)
      .then((response) => {
        if(response.data.code == 200){
          let data1={
            "hubDetailes":response.data.data
          }
           axios.post(apiUrl.api_url + 'external/EmpDetails/List',data1)
             .then((response1) => {
               //this.ShipmentData = response1.data.data;
               const commonData = [
                
                ['Shipping ID','Client Name','Zone','Hub Name','Status','Debit From',
                  'Total Shipment Value','Penalty','Debit Amount','Debit Concern Person (Agency name)','Debit SR details','Docket No','Debit Date',
                  'Lastmodified Date','Created By', 'Comments'
                ],
                [],
              ];
               
               let csvArrayExportObj = [];

              //  response1.data.data.forEach(function(item){

              //    let debitNames = item['DebitPersonalDetails'].map(function(childItem) {
              //       return childItem['SRName'];
              //     });
              //    csvArrayExportObj.push({
              //      "Shipping ID": item.ShippingID,
              //      "Client Name": item.ClientName,
              //      "Zone": item.HubZoneName,
              //      "Hub Name" : item.HubName,
              //      "Status":item.Status,
              //      "Debit From" : item.DebitFromType,
              //      "Total Shipment Value" :item.NetShipmentValue?item.NetShipmentValue:0,
              //      "Penalty":item.Penalty?item.Penalty:0,
              //      "Debit Amount" : item.totalDebitAmount?item.totalDebitAmoun:0,
              //      "Debit Concern Person" : debitNames.join('  -  '),
              //      "Docket No" : item.DocketNumber,
              //      "Debit Date" : item.CreatedDate,
              //      "Lastmodified Date" : item.LastModifiedDate,
              //      "Created By" : item.CreatedBy,
              //      "Comments" : item.Comments,

              //      }
              //    )
              //  });
              this.ShipmentData.forEach(function(item){

                let debitNames = item['DebitPersonalDetails'].map(function(childItem) {
                   return childItem['SRName'];
                 });
                 let debitAgencyNames = item['UniqueDebitFromList'].map(function(childItem) {
                  let agencyNameID=childItem['DebitFrom'] +' '+ '('+childItem['DebitID'] +')';
                  return agencyNameID;
                });
                
                let rsltDebitNames = debitNames.length>1 ? debitNames.map((item, index) => `${index + 1}) ${item}`).join('  '):debitNames[0];
                let rsltAgencyNames = debitAgencyNames.length>1 ? debitAgencyNames.map((item, index) => `${index + 1}) ${item}`).join('  '):debitAgencyNames[0];
                csvArrayExportObj.push([
                  item.ShippingID?item.ShippingID:'-',
                   item.ClientName?item.ClientName:'-',
                   item.HubZoneName?item.HubZoneName:'-',
                   item.HubName?item.HubName:'-',
                   item.Status?item.Status:'-',
                   item.DebitFromType?item.DebitFromType:'-',
                   item.NetShipmentValue?item.NetShipmentValue:0,
                  item.Penalty?item.Penalty:0,
                   item.totalDebitAmount?item.totalDebitAmount:0,
                   rsltAgencyNames,
                   rsltDebitNames,
                   item.DocketNumber?item.DocketNumber:'-',
                  item.CreatedDate?item.CreatedDate:'-',
                  item.LastModifiedDate?item.LastModifiedDate:'-',
                  item.CreatedBy?item.CreatedBy:'-',
                  item.Comments?item.Comments.replace(/[,\n]/g, ''):'-'

                ]
                )
              });
               this.ExportRmApproveLoaderBtn = false;
               this.exportCsv(csvArrayExportObj, commonData);
             })
           .catch((httpException) => {
               console.error('exception is:::::::::',httpException)
           });
        }else if(response.data.code == 204) {
          this.ExportRmApproveLoaderBtn = false;
          this.ShipmentData = [];
          this.$alertify.error("No Pending Approval");
        }else if(ExportRmApproveLoaderBtn.data.code == 202) {
          this.Loading = false;
          this.ShipmentData = [];
          this.$alertify.error(response.data.message);
        }else{
          this.ExportRmApproveLoaderBtn = false;
          this.ShipmentData = [];
          this.$alertify.error(response.data.message);
        }
      })
    .catch((httpException) => {
        console.error('exception is:::::::::',httpException)
    });
  }
  else {
    this.$alertify.error("To Date is greter than from Date");
  }
},
exportCsv(shipmentObjectdata, commonData=null) {
  let csvContent = "data:text/csv;charset=utf-8,";
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1;
  var yyyy = today.getFullYear();
  var today = dd + "" + mm + "" + yyyy;
  let filename = "StoreApproveDebit" + today + ".csv";
  commonData ? csvContent += 
        commonData.map(row => row.join(',')).join('\n') :null;
        

        csvContent += 
        shipmentObjectdata.map(row => row.join(',')).join('\n');
  // csvContent += [
  //   Object.keys(shipmentObjectdata[0]).join(";"),
  //   ...shipmentObjectdata.map(item => Object.values(item).join(";"))
  // ]
  // .join("\n")
  // .replace(/(^\[)|(\]$)/gm, "");

  const data = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", data);
  link.setAttribute("download", filename);
  link.click();
},
selectItems(ev) {
  this.selectedItems = [];
  this.shipmentDetails=[];
  if (ev.target.checked == true) {
      for (let i in this.ShipmentData) {
        console.log(this.ShipmentData)
        this.selectedItems.push(this.ShipmentData[i].ShipmentLostMasterID.toString());
        this.shipmentDetails.push(this.ShipmentData[i]);
      }
      this.shipmentDetails.forEach(element => {
        this.totalDebitAmount=parseFloat(this.totalDebitAmount)+parseFloat(element.DebitAmount)
        this.totalDebitAmount=this.totalDebitAmount.toFixed(2)
      });
  }else{
    this.totalDebitAmount=0;
  }
  
  this.totalSelectedRecords = this.selectedItems.length
  //this.calculateDebitAmout(this.amount,100);
},
   
    clear(){
      this.getServiceCentreList("");
      this.ShipmentType = '';
      this.awbnumbers = '';
      this.CenterType = ''
      this.totalSelectedRecords = 0
      this.totalDebitAmount=0;
      this.addDebitAmt=0;
      this.RMApproveAllRecord = '';
      this.fromDate = '';
      this.toDate = '';
      this.hubname='';
      this.hubzoneid='';
      this.debitFrom='';
      this.searchflag=false;
      this.ShippingId='';
      this.Percentage='';
      this.hubID='';
      this.CenterType = '';
      this.pageno = 1;
      this.$refs.paginate.selected= 0;
      this.pagecount = 0;
      this.selectedItems = [];
      this.shipmentDetails=[];
      this.errors.clear();
      this.hubList = [];
      this.hubStateId = ''
      this.hubCitybyStateList = [],
      this.hubCityId = ''
      this.AOR = '';
      this.selectedHubZoneId = '';
      this.selectedStateId = '';
      this.selectedCityId = '';
      this.selectedAOR = '';
      this.selectedCenterType = '';
      this.filteredHubList = [];
      // this.filterHubList();
    },
    closeApprovalResultModel() {
      this.modelValue =false
      this.selectedItems=[];
      this.totalDebitAmount=0;
      this.addDebitAmt=0;
      this.shipmentDetails=[];
    },
    onApproveClear() {
      this.selectedItems = [];
      this.shipmentDetails=[];
      this.totalDebitAmount=0;
      this.addDebitAmt=0;
      this.totalSelectedRecords = 0
    },
    async getServiceCentreList(selectedCentreType) {
      this.selectedCenterType = selectedCentreType
      let getMasterHubListDetails = await this.getMasterHubList();
      if ( selectedCentreType ) {
        this.filterHubList()
      }
    },
    getHubStateList(){
    var stateHub=[]
    this.hubAccessList.filter(element=>{
      const existingIndex = stateHub.findIndex(item => item.HubStateId === element.HubStateId);
          if (existingIndex != -1) {
            stateHub[existingIndex] = element;
        } else {
          stateHub.push(element);
        }
    });
    this.hubStateList=stateHub;
    },

    getCitiesbyState(event){
      this.selectedStateId = event.target.value;
      this.hubID=[];
      this.hubCityId='';
      this.filterHubList()
      const filtered=this.hubAccessList.filter(element=>(element.HubStateId===parseInt(event.target.value)));
      var cityHub=[]
      filtered.filter(element=>{
        const existingIndex = cityHub.findIndex(item => item.CityId === element.CityId);
            if (existingIndex != -1) {
              cityHub[existingIndex] = element;
          } else {
            cityHub.push(element);
          }
      });
      this.hubCitybyStateList=cityHub;
  },

  getAORList(){
    axios.get(apiUrl.api_url + 'external/AORList')
      .then((response) => {
        this.AORList = response.data.data;
      })
    .catch((httpException) => {
        console.error('exception is:::::::::',httpException)
    });
  },

  getHubsByCities(event){
    this.selectedCityId = event.target.value
    this.hubID=[];
    this.filterHubList()
  },

  getHubsByAOR(AOR){
    this.selectedAOR = AOR
    this.hubID=[];  
    this.filterHubList()
  },

  getHubsByZoneId(event){
    this.selectedHubZoneId = event.target.value;
    this.hubID=[];
    this.hubStateId='';
    this.hubCityId='';
    this.AOR='';
    this.CenterType='';
    this.selectedStateId = '';
    this.selectedCityId = '';
    this.selectedAOR = '';
    this.selectedCenterType = '';
    this.filterHubList()
  },

filterHubList() {
    this.isLoading = true;
    let result = this.allhubList;

    // Build a dynamic filter based on selected values
    const filters = [];

    // Add filter for HubZoneId if selected
    if (this.selectedHubZoneId) {
        filters.push(h => h.HubZoneId && h.HubZoneId == this.selectedHubZoneId);
    }

    // Add filter for HubStateId if selected
    if (this.selectedStateId) {
        filters.push(h => h.HubStateId && h.HubStateId == this.selectedStateId);
    }

    // Add filter for CityId if selected
    if (this.selectedCityId) {
        filters.push(h => h.CityId && h.CityId == this.selectedCityId);
    }

    // Add filter for AOR (soc) if selected
    if (this.selectedAOR) {
        filters.push(h => h.soc && h.soc.toLowerCase() === this.selectedAOR.toLowerCase());
    }

    // Add filter for CenterType if selected
    if (this.selectedCenterType) {
        filters.push(h => h.CenterType && h.CenterType.toLowerCase() === this.selectedCenterType.toLowerCase());
    }
    // Apply all filters
    result = result.filter(hub => filters.every(filter => filter(hub)));
    if(result.length==0){
      this.$alertify.error("No service center hubs found..!!");
    }
    // Set the filtered hub list
    this.filteredHubList = result;
    this.isLoading = false;
},


  getMasterHubList() {
    return new Promise((resolve,reject) => {
      try {
      this.isLoading = true;
      let data = {
        centerType : []
      }
        axios.post(apiUrl.api_url + 'external/filterHubDetails', data)
          .then((response) => {
            // this.masterHubList = response.data.data;
            let allHubdata = response.data.data;
            let filteredHubList = allHubdata.filter(o => this.hubAccessList.some(({HubID}) => o.HubID === HubID));
            let mergedArray = this.hubAccessList.map(obj1 => {
              let obj2 = filteredHubList.find(obj => obj.HubID === obj1.HubID);
              return Object.assign({}, obj1, obj2);
          });
            this.filteredHubList=mergedArray
            this.allhubList=this.filteredHubList;
            console.log("this.filteredHubList",this.allhubList)
            this.isLoading = false;
            resolve(this.allhubList)
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
            resolve([])
            this.isLoading = false;
          });
      } catch(e) {
        console.log('Error', e);
        resolve([])
        this.isLoading = false;
      }
    })
  },
  showDebitFromModal(shippingId){
    this.debitFromModal = true
    let debitDetails = this.ShipmentData.filter(x => x.ShippingID == shippingId)
    this.debitPersonDetails = debitDetails[0].DebitPersonalDetails;
    this.isScroll=this.debitPersonDetails.length>10? true:false;
  },
  closeDebitFromModal(){
    this.debitFromModal = false
  },
  showDebitAgencyModal(shippingId){
    this.debitAgencyModal = true
    let debitAgencyDetails = this.ShipmentData.filter(x => x.ShippingID == shippingId)
    this.debitAgencyDetails = debitAgencyDetails[0].UniqueDebitFromList;
    this.isScroll=this.debitAgencyDetails.length>10? true:false;
  },
  closeDebitAgencyModal(){
    this.debitAgencyModal = false
  },
    handleSelectAll() {
      this.hubID = this.selectAll ? this.filteredHubList.map(option => option) : [];
    },

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    moment2: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
}
$('.pane-hScroll').scroll(function() {
  $('.pane-vScroll').width($('.pane-hScroll').width() + $('.pane-hScroll').scrollLeft());
});



// WEBPACK FOOTER //
// ./src/views/components/LOST/StoreApproval/StoreApproval.component.js